export default "__VITE_ASSET__D3sd0g7K__"